import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from "@angular/common/http";
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideStore } from "@ngrx/store";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { routes } from "./app.routes";
import { indexReducer } from "./@core/store/index.reducer";
import { AppService } from './@core/services/app.service';
import {
  authInterceptor,
  authRefreshInterceptor,
  errorInterceptor,
  loadingInterceptor,
  sessionActivityInterceptor,
} from "./@core/authentication/interceptors";
import { NGX_ECHARTS_CONFIG } from "ngx-echarts";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([
      sessionActivityInterceptor,
      authInterceptor,
      errorInterceptor,
      loadingInterceptor,
      /** Innermost: handles 401 + refresh before `errorInterceptor` clears the session */
      authRefreshInterceptor,
    ])),
    provideStore({ index: indexReducer }),
    AppService,
      {
      provide: NGX_ECHARTS_CONFIG,
      useValue: {
        echarts: () => import("echarts"),
      },
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: "en",
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
  ],
};
